import { Radio } from 'antd';
import styled from 'styled-components';

export const Container = styled(Radio.Group)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '10rem',
  margin: 0,
  border: 'none',
  fontFamily: theme.typography.family.arial,

  '.ant-radio-wrapper-checked': {
    color: theme.palette.black,

    '.ant-radio-checked': {
      '.ant-radio-inner': {
        backgroundColor: theme.palette.white,
        borderColor: theme.palette.black,
        borderWidth: '2rem',

        '&:after': {
          backgroundColor: theme.palette.black,
          transform: 'scale(0.35)',
          border: '1rem solid theme.palette.black',
        },
      },
    },
  },

  '.ant-radio-wrapper': {
    fontFamily: theme.typography.family.arial,

    '&:hover': {
      color: theme.palette.artichoke,

      '.ant-radio': {
        '.ant-radio-inner': {
          backgroundColor: theme.palette.white,
          borderColor: theme.palette.artichoke,
          borderWidth: '2rem',

          '&:after': {
            transform: 'scale(0.35)',
            backgroundColor: theme.palette.artichoke,
            opacity: 1,
            border: `1rem solid ${theme.palette.artichoke}`,
          },
        },
      },
    },
  },
}));
